module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAGUlEQVQoU2NkmPX/PwMJgHFUAxGhNSJDCQBqqB8t8HDG/QAAAABJRU5ErkJggg=="